import styles from "./StatCard.module.css";

const StatCard = ({ title, value, subtitle, icon: Icon, iconVariant = "" }) => {
  const iconClassName = iconVariant ? styles[iconVariant] : "";
  return (
    <div className={styles.card}>
      <div className={styles.topRow}>
        <div className={styles.textWrap}>
          <p className={styles.title}>{title}</p>
          <h2 className={styles.value}>{value}</h2>
          {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
        </div>

        {Icon ? (
          <div className={[styles.iconWrap, iconClassName].filter(Boolean).join(" ")}>
            <Icon className={styles.icon} aria-hidden="true" />
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default StatCard;
